// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2kExT","subheader":"ReorderModal_subheader__1A23l","listWrap":"ReorderModal_listWrap__3W5SX"};